export enum LevelLayers {
  featured_cell_state = 'States',
  featured_cell_county = 'Counties',
  featured_cell_h3_res_5 = 'Cells (5 mile)',
  featured_cell_h3_res_7 = 'Cells (1 mile)',
}
